import {
  ArrowRightIcon,
  CashIcon,
  ClockIcon,
  LocationMarkerIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import React from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import AutoCompletePlaceItem from "../../../components/b2c/AutoCompletePlaceItem";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import Header from "../../../components/landingPage/Header";
import {
  changeDestinationInput,
  changeSourceInput,
  clearDestinationInput,
  clearSourceInput,
  setDestinationInput,
  setSourceInput,
} from "../../../redux/app/map/map-slice";
import {
  getVehicles,
  getVehiclesErr,
} from "../../../redux/app/vehicle/vehicle-slice";
import { BookingInputField } from "../NewBooking/NewBooking";
import GoogleIcon from "../../../assets/icons/google.png";
import { useState } from "react";
import InputField from "../../../components/landingPage/InputField";
import DatePicker from "react-date-picker";
// import "../NewBooking/DatePicker.css";
import moment from "moment";
import TimePicker from "../../../utils/TimePicker/TimePicker";
// import { TimePicker } from "react-ios-time-picker";
import {
  clearCurrency,
  clearPassenger,
  getDateTimeDetailIST,
  getDistanceInKm,
  getDuration,
  selectPassenger,
  setBookingDetails,
  setCurrency,
} from "../../../redux/app/booking/booking-slice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { faClock, faRoad } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import momenttz from "moment-timezone";

const OfflineBooking = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // states
  const [formSwitchOneWay, setformSwitchOneWay] = useState(true);
  const [dateValue, setDateValue] = useState();
  const [dateChange, setDateChange] = useState();
  const [timeValue, setTimeValue] = useState("10:00");
  const [timeChange, setTimeChange] = useState();
  const [openPassengerSelect, setopenPassengerSelect] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);
  const [hourlyTime, sethourlyTime] = useState();
  const [openHour, setOpenHour] = useState(false);
  const [tzUpdate, setTzUpdate] = useState();
  const [sourceRegionInput, setsourceRegionInput] = useState();
  const [destinationRegionInput, setdestinationRegionInput] = useState();
  const [openTimePicker, setOpenTimePicker] = useState(false);
  const [isTimeChange, setisTimeChange] = useState(false);
  const [sourceSuggestionOpen, setSourceSuggestionOpen] = useState(false);
  const [destinationSuggestionOpen, setDestinationSuggestionOpen] =
    useState(false);

  const duration = [
    {
      hour: 1,
      distance: 20,
    },
    {
      hour: 2,
      distance: 40,
    },
    {
      hour: 3,
      distance: 60,
    },
    {
      hour: 4,
      distance: 80,
    },
    {
      hour: 5,
      distance: 100,
    },
    {
      hour: 6,
      distance: 120,
    },
    {
      hour: 7,
      distance: 140,
    },
    {
      hour: 8,
      distance: 160,
    },
    {
      hour: 9,
      distance: 180,
    },
    {
      hour: 10,
      distance: 200,
    },
    {
      hour: 11,
      distance: 220,
    },
    {
      hour: 12,
      distance: 240,
    },
    {
      hour: 13,
      distance: 260,
    },
    {
      hour: 14,
      distance: 280,
    },
    {
      hour: 15,
      distance: 300,
    },
    {
      hour: 16,
      distance: 320,
    },
    {
      hour: 17,
      distance: 340,
    },
    {
      hour: 18,
      distance: 360,
    },
    {
      hour: 19,
      distance: 380,
    },
    {
      hour: 20,
      distance: 400,
    },
    {
      hour: 21,
      distance: 420,
    },
    {
      hour: 22,
      distance: 440,
    },
    {
      hour: 23,
      distance: 460,
    },
    {
      hour: 24,
      distance: 480,
    },
  ];
  // externals
  let time = dateChange + " " + timeChange;

  let passenger = [];
  for (let i = 0; i < 6; i++) {
    passenger.push(i + 1);
  }

  useEffect(() => {
    dispatch(clearSourceInput());
    dispatch(clearDestinationInput());
    setsourceRegionInput("");
    setdestinationRegionInput("");
  }, []);
  
  let Currency = [
    "USD",
    "INR",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "JPY",
    "AED",
    "CNY",
    "KWD",
    "NZD",
    "QAR",
    "SAR",
    "SGD",
    "OMR",
  ];

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  // selectors
  const { token } = useSelector((state) => state.auth);
  const {
    sourceInputFromApi,
    sourceInput,
    destinationInput,
    destinationInputFromApi,
    placesbygoogle,
    placesbygoogleForDestination,
  } = useSelector((state) => state.map);

  const {
    selectedPassenger,
    timeDetails,
    selectdCurrency,
    sourceLatLan,
    destinationLatLan,
    distanceInKm,
    isSearhingCar,
    sourceWithRegion,
    destinationWithRegion,
    airPorts,
    booking,
  } = useSelector((state) => state.booking);

  // handlers

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeSourceInput({
          sourceInput: sourceRegionInput,
        })
      );
      if (sourceRegionInput?.length > 2) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE",
          payload: sourceRegionInput,
        });
      }
    }, 800);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [sourceRegionInput]);

  const handleSourceChange = useCallback(
    (e) => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeSourceInput({
          sourceInput: e.target.value,
        })
      );

      dispatch({ type: "GET_PLACES_FROM_GOOGLE", payload: e.target.value });
    },
    [dispatch]
  );

  useEffect(() => {
    const getPlacesFromGoogleDataDestination = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeDestinationInput({
          destinationInput: destinationRegionInput,
        })
      );
      if (destinationRegionInput?.length > 3) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE_FOR_DEST",
          payload: destinationRegionInput,
        });
      }
    }, 1000);
    return () => clearTimeout(getPlacesFromGoogleDataDestination);
  }, [destinationRegionInput]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      sourceInput === undefined ||
      tzUpdate === undefined ||
      dateChange === undefined
    ) {
      toast.warning("Please fill all the fields", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
      });
    } else {
      const payload = {
        source: {
          placename: sourceInputFromApi?.description,
          placeid: sourceInputFromApi?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        destination: {
          placename: destinationInputFromApi?.description,
          placeid: destinationInputFromApi?.place_id,
          lat: destinationLatLan.split(",")[0],
          lng: destinationLatLan.split(",")[1],
        },
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
        timeZone: timeDetails.timezone,
      };

      const hourlyPayload = {
        source: {
          placename: sourceInputFromApi?.description,
          placeid: sourceInputFromApi?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        duration: hourlyTime?.hour,
        travelDistance: hourlyTime?.distance,
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
        timeZone: timeDetails?.timezone,
      };

      dispatch({
        type: "GET_DATE_TIME_DETAILS_IST",
        payload: {
          travellDateTime: tzUpdate,
          IndianTimezone: "Asia/Kolkata",
          travellTimeZone: timeDetails?.timezone,
        },
      });

      dispatch(
        setBookingDetails({
          booking: formSwitchOneWay ? payload : hourlyPayload,
        })
      );

      dispatch(
        getDuration({
          bookingDuration: hourlyTime?.hour,
        })
      );
      navigate("/offlinebooking/vehicles");
    }
  };

  // useEffect(()=>{
  //   dispatch(getDateTimeDetailIST({dateTimeIST:{}}))
  // },[])

  // useEffect(()=>{
  //
  //   // if(booking?.timeZone && booking?.travelTime){
  //     dispatch({
  //       type:"GET_DATE_TIME_DETAILS_IST",
  //       payload:{
  //         travellDateTime: booking?.travelTime,
  //         IndianTimezone:"Asia/Kolkata",
  //         travellTimeZone:booking?.timeZone
  //       }
  //     })
  //   // }
  // },[booking?.timeZone, booking?.travelTime])

  useEffect(() => {
    if (timeDetails?.timezone && !isTimeChange) {
      let timezonevalue = momenttz
        .tz(timeDetails.date_time, timeDetails?.timezone)
        .format("HH:mm");

      // setTimeValue(timezone.toString());
      setTimeValue(timezonevalue);
      setTimeChange(timezonevalue);
    }
  }, [timeDetails?.timezone, timeDetails?.date_time, isTimeChange]);

  const handleTimeChange = useCallback(
    (timeValue) => {
      setisTimeChange(true);

      setTimeValue(timeValue);
      setTimeChange(timeValue);
    },
    [dispatch, sourceInputFromApi]
  );

  // operations
  let allAirports = [];

  // effects
  useEffect(() => {
    let t = moment(time).format("YYYY-MM-DD HH:mm ");
    setTzUpdate(t);
  }, [timeDetails.timezone, time]);

  return (
    <div className="fixed w-screen max-h-full">
      {/* <div className="fixed w-screen scrollbar max-h-full overflow-y-auto"> */}
      <Header token={token} />
      <div className="flex">
        <SideBar />

        <div className="w-full my-5 h-screen">
          <div className="flex justify-between mx-3 sm:mx-10 text-center">
            <SearchResultHeading
              b2b={true}
              searchCurrent={true}
              showBookingDetail={false}
            />
          </div>

          <div className="relative">
            <div
              className="absolute w-full h-screen"
              onClick={() => {
                setopenPassengerSelect(false);
                setOpenCurrency(false);
                setSourceSuggestionOpen(false);
                setDestinationSuggestionOpen(false);
                setOpenHour(false);
                setOpenTimePicker(false);
              }}
            ></div>
            <div className="h-screen w-full my-5 px-3 sm:px-8 lg:px-16 xl:px-20">
              <div className="relative mt-6 sm:w-[86%] md:w-full lg:mx-0 mx-3 sm:mx-5 md:mx-0 shadow-md px-5 sm:px-10 md:px-5 border border-gray-300 rounded-md pt-5 pb-10">
                <div className="w-full mx-auto text-center">
                  <button
                    onClick={() => {
                      setformSwitchOneWay(true);
                    }}
                    className={` ${
                      formSwitchOneWay ? "text-secondary" : "text-gray-500 pl-7"
                    } sm:w-20 lg:w-36 h-8 text-sm font-semibold pt-[5px]`}
                  >
                    <div className="flex items-center space-x-2">
                      {formSwitchOneWay && (
                        <FontAwesomeIcon
                          icon={faRoad}
                          className="w-5  animate__animated animate__bounceIn"
                        />
                      )}
                      <div className="font-body">ONEWAY</div>
                    </div>
                  </button>
                  <button
                    onClick={() => {
                      setformSwitchOneWay(false);
                    }}
                    className={` ${
                      !formSwitchOneWay
                        ? "text-secondary pl-5"
                        : "text-gray-500 pl-7"
                    } sm:w-20 lg:w-36 h-8 text-sm font-semibold rounded-[2px] pt-[5px]`}
                  >
                    <div className="flex items-center space-x-2">
                      {!formSwitchOneWay && (
                        <FontAwesomeIcon
                          icon={faClock}
                          className="w-5  animate__animated animate__bounceIn"
                        />
                      )}
                      <div className="font-body">HOURLY</div>
                    </div>
                  </button>
                </div>
                <form action="" className="space-y-4 ">
                  {/* source input */}
                  <div className="space-y-4 ">
                    <BookingInputField
                      placeHolder="Address, Hotel, Airport"
                      Icon={LocationMarkerIcon}
                      label="From"
                      type="text"
                      value={
                        sourceInputFromApi
                          ? sourceInputFromApi?.terms[0]?.value +
                            " " +
                            sourceInputFromApi?.terms[1]?.value +
                            " " +
                            sourceInputFromApi?.terms[2]?.value
                          : sourceRegionInput
                      }
                      onChange={(e) => {
                        setsourceRegionInput(e.target.value);
                        setSourceSuggestionOpen(true);
                      }}
                      onClick={() => {
                        setOpenTimePicker(false);
                        setOpenCurrency(false);
                        setopenPassengerSelect(false);
                        setOpenHour(false);
                      }}
                      onKeyDown={(e) => {
                        if (
                          (e.key === "Backspace" ||
                            e.key === "Delete" ||
                            e.key.match(/([A-Z])/g) ||
                            e.key.match(/([a-z])/g)) &&
                          sourceInputFromApi
                        ) {
                          e.preventDefault();
                          dispatch(clearSourceInput());
                          setsourceRegionInput("");
                          if (e.key === "Backspace" || e.key === "Delete") {
                            setsourceRegionInput("");
                          } else {
                            setsourceRegionInput(e.key);
                          }
                        }
                      }}
                      onFocus={() => {
                        dispatch(
                          changeSourceInput({
                            sourceInput: "",
                          })
                        );
                      }}
                      onClickClear={() => {
                        dispatch(clearSourceInput());
                      }}
                    />

                    {/* show airports when airports match with input */}
                    {placesbygoogle.length > 0 && sourceSuggestionOpen && (
                      <>
                        <div className="bg-slate-100 absolute w-[65%] mx-20 -translate-x-20 h-72 transform scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                          <div className="overflow-y-auto">
                            {placesbygoogle?.map((place) => (
                              <>
                                <AutoCompletePlaceItem
                                  onClick={() => {
                                    // setting source input to input field and to redux store
                                    dispatch(
                                      setSourceInput({
                                        sourceInputFromApi: place,
                                      })
                                    );
                                    // and the same time finding lat an  lng to store to db and to get distance
                                    dispatch({
                                      type: "GET_LAT_LAN_OF_SOURCE",
                                      payload: place.place_id,
                                    });
                                  }}
                                  key={place?.place_id}
                                  placeTerms={place?.terms}
                                />
                              </>
                            ))}
                          </div>
                          <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                            <div className="text-sm font-semibold text-gray-400">
                              Powered By{" "}
                            </div>
                            <div>
                              <img
                                src={GoogleIcon}
                                alt="google icon"
                                className="w-5 h-5"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* source input end */}
                    {formSwitchOneWay ? (
                      <>
                        {/* destination input start */}
                        <BookingInputField
                          placeHolder="Address, Hotel, Airport"
                          Icon={LocationMarkerIcon}
                          label="To"
                          type="text"
                          value={
                            destinationInputFromApi
                              ? destinationInputFromApi?.terms[0]?.value +
                                " " +
                                destinationInputFromApi?.terms[1]?.value
                              : destinationRegionInput
                          }
                          onKeyDown={(e) => {
                            if (
                              (e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key.match(/([A-Z])/g) ||
                                e.key.match(/([a-z])/g)) &&
                              destinationInputFromApi
                            ) {
                              e.preventDefault();
                              dispatch(clearDestinationInput());
                              setdestinationRegionInput("");
                              if (e.key === "Backspace" || e.key === "Delete") {
                                dispatch(clearDestinationInput());
                              } else {
                                setsourceRegionInput(e.key);
                              }
                            }
                          }}
                          onFocus={() => {
                            dispatch(
                              changeDestinationInput({
                                destinationInput: "",
                              })
                            );
                          }}
                          onChange={(e) => {
                            setdestinationRegionInput(e.target.value);
                            setDestinationSuggestionOpen(true);
                          }}
                          onClick={() => {
                            setOpenTimePicker(false);
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setOpenHour(false);
                          }}
                          onClickClear={() => {
                            dispatch(clearDestinationInput());
                          }}
                        />

                        {placesbygoogleForDestination.length > 0 &&
                          destinationSuggestionOpen && (
                            <>
                              <div className="bg-slate-100 absolute w-[65%] mx-20 h-72 -translate-x-16 -translate-y-2  scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                                <div className="overflow-y-auto">
                                  {placesbygoogleForDestination?.map(
                                    (place) => (
                                      <>
                                        <AutoCompletePlaceItem
                                          onClick={() => {
                                            dispatch(
                                              setDestinationInput({
                                                destinationInputFromApi: place,
                                              })
                                            );

                                            dispatch({
                                              type: "GET_LAT_LAN_OF_DESTINATION",
                                              payload: place.place_id,
                                            });
                                          }}
                                          key={place?.place_id}
                                          placeTerms={place?.terms}
                                        />
                                      </>
                                    )
                                  )}
                                </div>
                                <div className="static flex items-center justify-end mx-3 space-x-1 text-left">
                                  <div className="text-sm font-semibold text-gray-400 ">
                                    Powered By{" "}
                                  </div>
                                  <div>
                                    <img
                                      src={GoogleIcon}
                                      alt="google icon"
                                      className="w-5 h-5"
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        {/* destination input end */}
                      </>
                    ) : (
                      <>
                        <BookingInputField
                          placeHolder="1 hour (20 Km)"
                          Icon={LocationMarkerIcon}
                          label="Duration"
                          type="text"
                          value={
                            hourlyTime
                              ? hourlyTime?.hour +
                                " hour (" +
                                hourlyTime?.distance +
                                " Km)"
                              : ""
                          }
                          onClick={() => {
                            setOpenHour(true);
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setSourceSuggestionOpen(false);
                            setDestinationSuggestionOpen(false);
                            setOpenTimePicker(false);
                          }}
                        />

                        {openHour && (
                          <>
                            <div className="bg-slate-100 absolute w-auto h-60 scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10 overflow-y-auto">
                              <div>
                                {duration.map((dur) => (
                                  <div
                                    key={dur.hour}
                                    onClick={() => {
                                      console.log("distance dur",dur)
                                      sethourlyTime(dur);
                                      dispatch(
                                        getDistanceInKm({
                                          distance: dur.distance,
                                        })
                                      );
                                      setOpenHour(false);
                                    }}
                                    className="flex items-center px-3 py-2 space-x-3 rounded-sm cursor-pointer bg-slate-100 hover:bg-secondary hover:text-white"
                                  >
                                    <div className="flex space-x-2 ">
                                      <span>{dur.hour} </span>
                                      <span>
                                        {dur.hour > 1 ? "hours" : "hour"}
                                      </span>
                                      <span>({dur.distance} kms)</span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>

                  <div className="gap-5 md:flex md:space-x-2">
                    <div className="w-full grow">
                      {/* <BookingInputField
                      Icon={CalendarIcon}
                      placeHolder="01/01/2022"
                      label="Date"
                      inputType="text"
                      value={dateValue}
                      onClick={() => {
                        setopenDatePicker(true);
                      }}
                    
                    /> */}

                      <div className="w-full offlinebooking">
                        <div className="text-sm font-semibold font-body text-gray-800">
                          Date
                        </div>
                        <DatePicker
                          className="w-24 "
                          format="dd-MM-y"
                          dayPlaceholder="DD"
                          monthPlaceholder="MM"
                          yearPlaceholder="YYYY"
                          // minDate={new Date()}
                          minDate={new Date(moment().subtract(1, "day"))}
                          onChange={(e) => {
                            setDateValue(e);
                            setDateChange(moment(e).format("yyyy-MM-DD"));
                          }}
                          onClick={() => {
                            setOpenCurrency(false);
                            setopenPassengerSelect(false);
                            setSourceSuggestionOpen(false);
                            setDestinationSuggestionOpen(false);
                            setOpenTimePicker(false);
                            setOpenHour(false);
                          }}
                          value={dateValue}
                        />
                      </div>
                    </div>
                    <div className="relative w-full grow mt-4 md:mt-0">
                      <div>
                        <div className="text-sm font-semibold font-body text-gray-800">
                          Time
                        </div>
                        <div className="flex space-x-2">
                          <input
                            type="time"
                            value={timeValue}
                            onClick={() => {
                              setOpenTimePicker(true);
                              setOpenCurrency(false);
                              setopenPassengerSelect(false);
                              setSourceSuggestionOpen(false);
                              setDestinationSuggestionOpen(false);
                              setOpenHour(false);
                            }}
                            onChange={(e) => {
                              setisTimeChange(true);

                              setTimeValue(e.target.value);
                              setTimeChange(e.target.value);
                            }}
                            // 24 hours format
                          />
                          <ArrowRightIcon className="w-5" />
                          {/* </DemoContainer> */}
                          {/* </LocalizationProvider> */}

                          {/* {openTimePicker && (
                            <div className="absolute translate-y-5 ">
                              <div className="animate__animated animate__fadeIn ">
                                <TimePicker
                                  onHandleTimeChange={handleTimeChange}
                                  onClickClose={() => {
                                    setOpenTimePicker(false);
                                  }}
                                  timeValue={timeValue}
                                />
                              </div>
                            </div>
                          )} */}
                          <div
                            className="textField  cursor-pointer"
                            onClick={() => {
                              setOpenTimePicker(true);
                              setOpenCurrency(false);
                              setopenPassengerSelect(false);
                              setSourceSuggestionOpen(false);
                              setDestinationSuggestionOpen(false);
                              setOpenHour(false);
                            }}
                          >
                            {timeValue}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-row gap-5 md:flex md:space-x-2">
                    <div className="w-full grow sm:mb-3">
                      <BookingInputField
                        Icon={UsersIcon}
                        placeHolder="Select passenger"
                        label="Passenger"
                        value={selectedPassenger}
                        onClickClear={() => {
                          dispatch(clearPassenger());
                        }}
                        onChange={() => {}}
                        onClick={() => {
                          setopenPassengerSelect(true);
                          setOpenCurrency(false);
                          setSourceSuggestionOpen(false);
                          setDestinationSuggestionOpen(false);
                          setOpenTimePicker(false);
                          setOpenHour(false);
                        }}
                      />

                      {/* passenger dropdown start */}
                      {openPassengerSelect && (
                        <>
                          <div className="bg-slate-100 absolute w-auto h-auto mx-20 transform -translate-y-5 -translate-x-20 scrollbar rounded-bl-md rounded-br-md shadow-2xl overflow-y-auto">
                            <div>
                              {passenger.map((passenger) => (
                                <>
                                  <div
                                    key={passenger}
                                    onClick={() => {
                                      dispatch(
                                        selectPassenger({
                                          selectedPassenger:
                                            passenger +
                                            ` ${
                                              passenger > 1
                                                ? "Passengers"
                                                : "Passenger"
                                            } `,
                                        })
                                      );
                                      setopenPassengerSelect(false);
                                    }}
                                    className="flex items-center px-5 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                  >
                                    <span>{passenger}</span>
                                    <span>
                                      {passenger > 1
                                        ? "Passengers"
                                        : "Passenger"}
                                    </span>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="w-full grow mt-4 md:mt-0">
                      <BookingInputField
                        Icon={CashIcon}
                        placeHolder="Select Currency"
                        label="Currency"
                        value={selectdCurrency}
                        onClickClear={() => {
                          dispatch(clearCurrency());
                        }}
                        onChange={() => {}}
                        onClick={() => {
                          setOpenCurrency(true);
                          setopenPassengerSelect(false);
                          setSourceSuggestionOpen(false);
                          setDestinationSuggestionOpen(false);
                          setOpenTimePicker(false);
                          setOpenHour(false);
                        }}
                      />

                      {openCurrency && (
                        <>
                          <div className="bg-slate-100 absolute w-[30%] md:w-[25%] lg:w-[20%] mx-20 h-48 transform -translate-x-20 -translate-y-5  scrollbar rounded-bl-md rounded-br-md shadow-2xl">
                            <div className="overflow-y-auto scrollbar max-h-48">
                              {Currency.map((c, index) => (
                                <>
                                  <div
                                    key={index}
                                    onClick={() => {
                                      dispatch(
                                        setCurrency({
                                          selectdCurrency: c,
                                        })
                                      );
                                      setOpenCurrency(false);
                                    }}
                                    className="flex items-center px-3 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                                  >
                                    <span>{c}</span>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {/* passenger dropdown end */}

                  <button
                    onClick={handleSubmit}
                    className={`outline outline-1 outline-[#c4c6ca] text-[#FB4156] ${
                      isSearhingCar && "cursor-not-allowed"
                    } hover:outline-[#fb4156] hover:outline-2 w-1/2 mx-auto justify-center mt-10 flex font-bold text-mb py-2 rounded-sm font-body`}
                  >
                    {!isSearhingCar ? (
                      "BOOK A RIDE"
                    ) : (
                      <>
                        <div className="flex items-center justify-center space-x-2">
                          <div>Searching cars</div>

                          <div role="status" className="flex justify-center ">
                            <svg
                              aria-hidden="true"
                              className="mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                            <span className="sr-only ">Loading...</span>
                          </div>
                        </div>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineBooking;
